import {Injectable} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {UserRepresentation} from '../models/UserRepresentation';
import {CookieService} from 'ngx-cookie-service';
import {ConfigService} from './config.service';
import {LocalStorageService} from './local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(private configService: ConfigService,
                private cookieService: CookieService,
                private keycloakService: KeycloakService,
                private localStorage: LocalStorageService) {
    }

    getLoggedUser(): Promise<UserRepresentation> {
        return this.keycloakService.loadUserProfile().then((u: UserRepresentation) => ({id: this.keycloakService.getKeycloakInstance().subject, enabled: true, ...u} as UserRepresentation));
    }

    logout(): Promise<void> {
        this.cookieService.deleteAll();
        this.localStorage.clear();
        return this.keycloakService.logout();
    }

    hasSystemAccess(): boolean {
        return !!this.keycloakService.getKeycloakInstance().authenticated;
    }

}